import Controller from '../utilities/layout-editor-base-controller';
import { maxBy, reject, filter, find, includes, remove } from 'lodash';
import EventPublisher from '../utilities/event_publisher';
import Client from '../utilities/layouts/client';
import Renderer from '../utilities/layouts/renderer';
import { flashAlert } from '../shared/flash'
import { POSITION_FILL_COLOR, POSITION_HIGHLIGHT_COLOR } from '../utilities/layouts/render_properties';

export default class extends Controller {
  static targets = this.targets.push(
    'sectionsTab',
    'landmarksTab'
  )

  connect() {
    this.loadLayout(Client, Renderer);
    window.addEventListener('landmark-added', this.onLandmarkAdded);
    window.addEventListener('landmark-removed', this.onLandmarkRemoved);
    window.addEventListener('landmark-selected', this.showLandmarks);
    window.addEventListener('position-added', this.onPositionAdded);
    window.addEventListener('position-removed', this.onPositionRemoved);
    window.addEventListener('position-selected', this.showProducts);
    window.addEventListener('section-highlighted', this.onSectionHighlighted);
    window.addEventListener('section-unhighlighted', this.onSectionUnHighlighted);
    window.addEventListener('position-highlighted', this.onPositionHighlighted);
    window.addEventListener('position-unhighlighted', this.onPositionUnHighlighted);
  }

  onLandmarkAdded = event => {
    const { landmark } = event.detail;
    this.landmarks.push(landmark);
    this.renderer.renderLandmark(landmark);
  }

  onLandmarkRemoved = event => {
    const { landmark } = event.detail;
    remove(this.landmarks, { id: landmark.id }); //eslint-disable-line lodash/prefer-immutable-method
    this.renderer.landmarks = this.landmarks;
  }

  onPositionAdded = event => {
    const { position } = event.detail;
    const maxID = maxBy(this.positions, 'id')?.id || 0;
    position.id = maxID + 1;
    this.positions.push(position);
    this.renderer.renderPosition(position);
  }

  onSectionHighlighted = event => {
    const { positionIds } = event.detail;
    const positions = filter(this.positions, pos => includes(positionIds, pos.id));
    positions.forEach(pos => pos.setFillColor(POSITION_HIGHLIGHT_COLOR));
  }

  onSectionUnHighlighted = event => {
    const { positionIds } = event.detail;
    const positions = filter(this.positions, pos => includes(positionIds, pos.id));
    positions.forEach(pos => pos.setFillColor(POSITION_FILL_COLOR));
  }

  onPositionHighlighted = event => {
    const { positionId } = event.detail;
    const position = find(this.positions, { id: positionId });
    position.setFillColor(POSITION_HIGHLIGHT_COLOR);
  }

  onPositionUnHighlighted = event => {
    const { positionId } = event.detail;
    const position = find(this.positions, { id: positionId });
    position.setFillColor(POSITION_FILL_COLOR);
  }

  async handleSave() {
    const confirmed = confirm('Are you sure you want to save these changes?'); // eslint-disable-line no-alert
    if (!confirmed) return;
    const { layout, error } = await this.client.saveLayout(this.positions, this.landmarks, this.sections);
    if (layout) {
      EventPublisher.publish('layout-saved');
      window.location = `/sandbar/admin/layouts/${layout.id}/edit`;
    } else {
      flashAlert(error);
    }
  }

  onPositionRemoved = event => {
    const { position } = event.detail;
    this.positions = reject(this.positions, { id: position.id });
    this.renderer.positions = this.positions;
  }

  showLandmarks = () => {
    this.activateTab(this.landmarksTabTarget);
    this.activateView(this.landmarksTarget);
  }

  showSections = () => {
    this.activateView(this.sectionsTarget);
    this.activateTab(this.sectionsTabTarget);
  }

  getViewTargets() {
    return [
      this.manageProductsTarget,
      this.productsTarget,
      this.landmarksTarget,
      this.sectionsTarget
    ];
  }

  align = event => {
    this.renderer.align(event.params.direction);
  }

  distribute = event => {
    this.renderer.distribute(event.params.direction);
  }
}
